/*
===============================================================================================================
                                 Copyright 2022-2026, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

export const valueIds = {
  DOMESTIC_PORTAL: Symbol('DOMESTIC_PORTAL'),
  INTERNATIONAL_PORTAL: Symbol('INTERNATIONAL_PORTAL'),
  COLLECTION_WIDGET: Symbol('COLLECTION_WIDGET'),
  CUSTOMER_JOURNEY: Symbol('CUSTOMER_JOURNEY'),
};

const settings = {
  TRADING_NAME: Symbol('trading-name'),
  LEGAL_ENTITY: Symbol('legal-entity'),
  MERCHANT_STATUS: Symbol('merchant-status'),
  CUSTOMER_NAME: Symbol('customer-name'),
  CUSTOMER_EMAIL: Symbol('customer-email'),
  CUSTOMER_PHONE: Symbol('customer-phone'),
  CUSTOMER_JOURNEY: Symbol('customer-journey'),
  DOMESTIC_PRICING_TIERS: Symbol('domestic-pricing-tiers'),
  DOMESTIC_LOCATION_ID: Symbol('domestic-location-id'),
  DOMESTIC_CHARGE_ACCOUNT: Symbol('domestic-charge-account'),
  INTERNATIONAL_LOCATION_ID: Symbol('international-location-id'),
  INTERNATIONAL_CHARGE_ACCOUNT: Symbol('international-charge-account'),
  INTERNATIONAL_PRICING_TIERS: Symbol('international-pricing-tiers'),
  CUSTOMER_USERNAME: Symbol('customer-username'),
};

const getValue = ({
  changes,
}) => (value) => {
  const settingsValue = settings[value];
  // If this is something with an outstanding change, take that
  const fieldChange = changes?.find((change) => change.valueId === value);
  if (fieldChange) {
    return fieldChange.value;
  }

  if (settingsValue === settings.CUSTOMER_JOURNEY) {
    return value ?? null;
  }
  return null;
};

export default getValue;
